import { USER_PRIVILEGES_ROUTING } from '../config/privileges';

export const getPreloadPromise = (privileges, actions) => {
  const {
    fetchGetAccountInfo,
    fetchGetDeliveryInfo,
    fetchGetWarehouses,
    fetchGetOrganizationSettings,
    fetchGetCheckoutSettings,
    fetchGetCountriesList,
    fetchGetPriceSettings,
    fetchGetPaymentSettings,
  } = actions;

  const promiseArr = [
    fetchGetAccountInfo(),
    fetchGetDeliveryInfo(),
    fetchGetWarehouses(),
    fetchGetOrganizationSettings(),
    fetchGetCheckoutSettings(),
    fetchGetCountriesList(),
    fetchGetPriceSettings(),
  ];

  if (privileges.includes('ADMIN') || privileges.includes('SETTINGS_READ')) {
    promiseArr.push(fetchGetPaymentSettings());
  }

  return Promise.all(promiseArr);
};

export const getBasicRedirectRoute = (privileges, ordersResult = {}) => {
  if (!privileges) {
    return '';
  }
  if (privileges.includes('ADMIN')) {
    return 'orders';
  }
  if (privileges.includes('ORDERS_READ') || privileges.includes('ORDERS_WRITE')) {
    return 'orders';
  }
  if (
    privileges.includes('PHYSICAL_SET_ORDER_READ') ||
    privileges.includes('PHYSICAL_SET_ORDER_WRITE')
  ) {
    if (privileges.includes('DASHBOARD_DATA_READ')) {
      return 'summary';
    }
    return 'items';
  }
  if (privileges.includes('DASHBOARD_DATA_READ')) {
    return 'summary';
  }
  if (privileges.includes('PRODUCTS_READ') || privileges.includes('PRODUCTS_WRITE')) {
    return 'items';
  }
  if (privileges.includes('PURCHASE_ORDERS_READ') || privileges.includes('PURCHASE_ORDERS_WRITE')) {
    return 'supplies';
  }
  if (privileges.includes('SETTINGS_READ') || privileges.includes('SETTINGS_WRITE')) {
    return 'settings';
  }
};

export const getRoutingByPrivileges = (privileges) =>
  Array.from(new Set(privileges.map((p) => USER_PRIVILEGES_ROUTING[p] || []).flat()));

export const checkRouteAccessibility = (privileges, path, account) => {
  if (path === 'https://studio.kak2c.ru/') return true;
  if (path === 'finances' && !account.displayFinance) return false;
  if (path === 'admin') return true;
  return getRoutingByPrivileges(privileges).includes(path);
};
